import { Button, Stack } from '@monorepo/nova-ui';
import { styled } from '@mui/material/styles';

export const StyledSocialIconsContainer = styled(Stack)(({ theme }) => ({
  flexDirection: 'column',
  gap: theme.spacing(8),
  [theme.breakpoints.up('md')]: {
    gap: theme.spacing(4),
  },
  [theme.breakpoints.up('xl')]: {
    flexDirection: 'row',
    gap: theme.spacing(20),
  },
}));

export const StyledIconGroup = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(2),
}));

export const StyledIconsRow = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  gap: theme.spacing(4),
}));

export const StyledIconLink = styled('a')(() => ({
  textDecoration: 'none',
  display: 'inline-block',
}));

export const StyledIconButton = styled(Button)(() => ({
  width: 32,
  height: 32,
  padding: '0 !important',
  minWidth: 'unset !important',
  minHeight: 'unset !important',
}));
